import { DefaultTheme } from 'styled-components'

const breakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
}

const breakpointsV2 = {
  mobile: 375,
  tablet: 768,
  desktop: 1280,
}

const appTheme: DefaultTheme = {
  media: {
    sm: `(min-width: ${breakpoints.sm}px)`,
    md: `(min-width: ${breakpoints.md}px)`,
    lg: `(min-width: ${breakpoints.lg}px)`,
    xl: `(min-width: ${breakpoints.xl}px)`,
  },
  clients: {
    colors: {
      white: '#ffffff',
      black: {
        _60: '#757575',
        _100: '#222222',
      },
      silver: {
        _10: '#F7F8FA',
        _30: '#DBDDE3',
        _50: '#C0C4CE',
        _70: '#A6AAB6',
        _100: '#6E7585',
      },
      lightGreen: '#0bbe78',
      greenishTeal: '#4fd7a2',
      gray: '#777777',
      green: '',
      red: '#ff0000',
      orange: {
        _10: '',
        _30: '',
        _50: '#EB592B',
        _70: '',
        _100: '',
      },
      appleGreen: {
        _90: '#21993D',
      },
    }
  },
  members: {
    colors: {
      lightGreen: '#0BBE78',
      white: '#ffffff',
      black: {
        _60: '#757575',
        _100: '#222222',
      },
      gray: '#777777',
      green: '#0BBE78',
      appleGreen: {
        _10: '#E7FAEC',
        _60: '#0BBE78',
        _90: '#21993D',
      },
      emeraldGreen: {
        _40: '#52AB88',
        _60: '#088755',
      },
      red: '#f15252',
      pink: '#ffeded',
      orange: {
        _50: '#EB592B',
        _80: '#E03100',

      },
      lightGray: '#DBDDE3',
      silver: {
        _10: '#F7F8FA',
        _30: '#DBDDE3',
        _50: '#C0C4CE',
        _70: '#A6AAB6',
        _100: '#6E7585',
      },
    },
    flash: {
      colors: {
        success: 'rgba(6, 170, 106, 0.8)',
        notice: 'rgba(6, 170, 106, 0.8)',
        alert: 'rgba(241, 82, 82, 0.8)',
        error: 'rgba(241, 82, 82, 0.8)',
      }
    }
  },
}

export { appTheme, breakpoints, breakpointsV2 }
